import React from 'react'
import Brand_slider from './Brand_slider'
import Mobile_view_brand from './Mobile_view_brand'

function Main_Brand_slider() {
  return (
    <div>
      {/* ----------------mobile view----------------- */}
      <div className='d-sm-block  d-md-none'>
        <div className=''>
          <div className='Mobile_Brand_slider_text'>
              <div className='pt-4'>
              <p className='px-2'>Our Alumni Works At</p>
              </div>
          </div>
        <div className='conatiner-fluid'>
          <div className='container'>
          <div className='d-sm-block d-md-none'>
            <Mobile_view_brand/>
          </div>
          <div className='d-none d-md-block'>
          <Brand_slider/>
          </div>
          </div>
        </div>
        </div>
      </div>

      {/* -------------------Desktop View------------------- */}
      <div className='d-none d-md-block'>
        <div className=''>
        <div className='container '>
            <div className='Brand_slider_text'>
                <h1 className=''>Our Alumni Works At</h1>
            </div>
        </div>
        <div className='conatiner-fluid mt-4'>
          <div className='container'>
          <div className='d-sm-block d-md-none'>
            <Mobile_view_brand/>
          </div>
          <div className='d-none d-md-block'>
          <Brand_slider/>
          </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Main_Brand_slider

